export const appDesktopSportsCountryBlocker: string[] = ['NL', 'DE', 'HU'];

export const appDesktopCasinoCountryBlocker: string[] = ['NL', 'DE', 'HU'];

export const appMobileSportsCountryBlocker: string[] = ['NL', 'DE'];

export const appMobileCasinoCountryBlocker: string[] = ['NL', 'DE'];
